import React from 'react';

interface ToolbarButtonProps {
  title: string;
  onClick: () => void;
  icon: string;
  className?: string;
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  title,
  onClick,
  icon,
  className = '',
}) => {
  return (
    <button
      type="button"
      className={`p-1.5 rounded-full hover:bg-white-500/50 text-white/80 hover:text-white transition-colors duration-150 ${className}`}
      title={title}
      onClick={onClick}
      onMouseDown={(e) => e.preventDefault()}>
      <i className={`${icon} text-sm`} />
    </button>
  );
};
